import { ScrollText } from 'lucide-react';
import LegalDocumentPage from '../components/LegalDocumentPage';

export default function TermsOfService() {
  return (
    <LegalDocumentPage
      title="Terms of Service"
      pdfPath="/terms-of-service.pdf"
      icon={ScrollText}
      intro="These Terms of Service govern your use of SkipdQ as a student or vendor. The complete agreement is in the PDF below."
    />
  );
}
